import * as d3 from 'd3'

export default {
  methods: {
    
    gantt_Header() {

      let headCanvas = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.gantt.x}, ${this.gantt.y})`)

      headCanvas
      .append('path') // shadow
      .attr('d', `M 30, ${this.gantt.height + 2} H ${this.timeline.length+this.gantt.width - 30} L ${this.timeline.length + this.gantt.width},${this.gantt.height + 8} H0 Z`)
      .attr('fill', `url(#shadowTimeline)`) 

      headCanvas
      .append('rect') 
      .attr('x', 0).attr('y', 0).attr('width', this.gantt.width).attr('height', 2)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .99)

      headCanvas
      .append('rect')
      .attr('x', 0).attr('y', 3).attr('width', this.gantt.width).attr('height', this.gantt.height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      // Time Now
      headCanvas
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('width', this.gantt.width + this.timeline.scale(new Date(this.cutoff)))
      .attr('height', this.gantt.height)
      .attr('fill', `url(#${this.localId}_LightBlue_)`).attr('opacity', .5)

      headCanvas
      .append('rect') 
      .attr('x', 0).attr('y', this.gantt.height + 1).attr('width', this.gantt.width).attr('height', 2)
      .attr('fill', `url(#${this.localId}_LightGray_)`)

      
      let item = headCanvas
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.gantt.columns.forEach((col, c)=> {
        item
        .append('text')
        .attr('x', col.mx).attr('y', col.group=='Y' ? this.gantt.depth[1] : this.gantt.depth[2])
        .attr('font-size', c<2 ? 10 : 9)
        .attr('fill', c<2 ? '#000' : '#333')
        .attr('text-anchor', 'middle')
        .text(col.name)
      })

      this.gantt.colspan.forEach((col, c)=> {
        let x_ = this.gantt.columns[col.start].sx + (this.gantt.columns[col.finish].ex - this.gantt.columns[col.start].sx)/2
        this.gmx_Text(item, '', x_, this.gantt.depth[0], col.tSize, col.tColor, 'middle', '', col.name)
      })

    },



    draw_Timeline() {    

      let Timeline = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.gantt.x + this.gantt.width -0.5}, ${this.gantt.y})`)

      Timeline
      .append('rect') 
      .attr('x', 0).attr('y', 0).attr('width', this.timeline.length).attr('height', 2)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .99)

      Timeline
      .append('rect')
      .attr('x', 0).attr('y', 3).attr('width', this.timeline.length).attr('height', this.gantt.height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      Timeline
      .append('rect') 
      .attr('x', 0).attr('y', this.gantt.height + 1).attr('width', this.timeline.length).attr('height', 2)
      .attr('fill', `url(#${this.localId}_LightGray_)`)


      // Month Text & Timeline Seperator for the Month
      let month_ = this.timeline.styles.month
      this.timeline.month.forEach((d,i)=> {
        Timeline
        .append('text')
        .attr('x', this.timeline.scale(d.mDate)).attr('y', month_.y)
        .attr('font-size', month_.tSize).attr('fill', month_.tColor).attr('text-anchor', 'middle')
        .text(d.name.toUpperCase())

        Timeline
        .append('line')
        .attr('x1', this.timeline.scale(d.eDate)).attr('y1', this.gantt.height - month_.tSize)
        .attr('x2', this.timeline.scale(d.eDate)).attr('y2', this.gantt.height)
        .attr('stroke', month_.stroke).attr('oapcity', .5)
        .attr('stroke-width', (i !== this.timeline.month.length-1) ? .5 : 0)
      })


      // Year Text & Timeline Seperator for the Year
      let year_ = this.timeline.styles.year
      this.timeline.year.forEach((d,i)=> {
        Timeline
        .append('text')
        .attr('x', this.timeline.scale(d.mDate)).attr('y', year_.y)
        .attr('font-size', year_.tSize).attr('fill', year_.tColor).attr('text-anchor', 'middle')
        .text(d.name)

        Timeline
        .append('line')
        .attr('x1', this.timeline.scale(d.eDate)).attr('y1', 2)
        .attr('x2', this.timeline.scale(d.eDate)).attr('y2', this.gantt.height)
        .attr('stroke', year_.stroke).attr('oapcity', .1)
        .attr('stroke-width', (i !== this.timeline.year.length-1) ? .5 : 0)
      })

      
    }, 
  }
}
